declare const window: WindowTypes;

export interface EventClickPromoProps {
  anotherCategory?: string;
  category?: string;
  id?: string | number;
  index?: string | number;
  slug?: string;
  title?: string;
  tag?: string;
}

const eventClickPromo = (params: EventClickPromoProps) => {
  if (typeof window !== 'undefined' && params) {
    window?.dataLayer?.push({
      event: `promotionClick`,
      eventCategory: `ecommerce promotion`,
      eventLabel: `${(params?.anotherCategory ?? params?.category ?? '').toLowerCase()}`,
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: `${params?.id}`,
              name: `${params?.title?.toLowerCase() || 'Tidak Tersedia'}`,
              creative: `/promosi/${params?.category
                ?.replace(/ /g, '-')
                .toLowerCase()}/${params?.slug?.toLowerCase()}`,
              position: `${params?.index} - promosi ${params?.category
                ?.replace(/-/g, ' ')
                .toLowerCase()}`,
            },
          ],
        },
      },
    });
  }
};
export default eventClickPromo;
